import isObject from 'lodash-es/isObject';
import isString from 'lodash-es/isString';

import { ApiAuthResponse } from './Auth';
import Base from './Base';

class Subscriptions extends Base {
    subscribe(handle, data = null, opts = null) {
        return this.postJSONWithSession<ApiAuthResponse>(
            isString(handle) ? `/subscription/${handle}` : `/subscription`,
            isObject(handle) ? handle : data,
            opts,
        );
    }

    unsubscribe(handle, data, opts = null) {
        return this.postJSONWithSession<User>(
            isString(handle) ? `/subscription/${handle}` : `/subscription`,
            {
                ...(isObject(handle) ? handle : data),
                _method: 'DELETE',
            },
            opts,
        );
    }
}

export default Subscriptions;
